import axios from 'axios';
import { endWebSession } from './session';

// --- 1. EXPORT THE SERVER URL ---
// This handles your images and files perfectly in both Local and Live environments
export const SERVER_URL = process.env.NODE_ENV === 'production'
  ? ''
  : `${window.location.protocol}//${window.location.hostname}:5000`;

// --- 2. SET UP API BASE URL ---
const baseURL = `${SERVER_URL}/api`;

const api = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
    'x-client-platform': 'web'
  }
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response, 
  (error) => {
    /*
     * The server refused the sign-in this request carried: the session ran out
     * or was ended (utils/session.js). Sign out and go to the login page now,
     * and never settle this request: the page is leaving, and its own "could
     * not be loaded" message would only flash up on the way out.
     */
    const sentToken = Boolean(error.config?.headers?.['x-auth-token']);
    const signingIn = String(error.config?.url || '').includes('/auth/login');
    if (error.response && error.response.status === 401 && sentToken && !signingIn) {
      endWebSession(error.response.data?.reason || 'ended');
      return new Promise(() => {});
    }
    // 413 with nothing readable in it: the upload was refused for its size by
    // something in front of the app (a proxy), which answers with a bare page.
    // Give it the message every screen already looks for, so the person is
    // told the file was too big instead of a generic "failed".
    if (error.response && error.response.status === 413 && !error.response.data?.message) {
      error.response.data = {
        code: 'FILE_TOO_LARGE',
        message: 'File too large. The server refused the upload because of its size. Try a smaller file.'
      };
    }
    return Promise.reject(error);
  }
);

export default api;
